<template>
  <div class="Receiving bj">
    <div class="title">
      <el-button
        type="primary"
        icon="el-icon-refresh"
        class="bjsearch"
        @click="Refresh"
      ></el-button>
      <!-- <el-button type="primary" @click="search">生成接货单</el-button> -->
      <div class="seach">
        <div class="times">
          <el-date-picker
            v-model="value1"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>

        <!-- <div class="inputs">
          <el-input
            placeholder="输入接货单号"
            v-model="from.supplier_name"
            clearable
          ></el-input>
        </div> -->

        <el-button type="primary" icon="el-icon-search" @click="search"
          >查询</el-button
        >
      </div>
    </div>
    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column type="index" width="100px" align="center" label="序号">
        </el-table-column>
        <el-table-column
          prop="receive_order_no"
          align="center"
          label="接货单号"
        >
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.receive_order_no) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          align="center"
          label="创建日期"
        >
          <template slot-scope="scope">
            {{ $empty.time(scope.row.create_time) }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="from.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
  <script>
export default {
  name: "Receiving",
  inject: ["reload"],
  components: {},
  data() {
    return {
      //列表新建页面初始参数
      loading: false,
      from: {
        create_time:'',
        page: 1,
        pageSize: 10,
      },
      from1: {
        create_time:'',
        page: 1,
        pageSize: 10,
      },
      value1: [],
      tableData: [],
      currentPage: 1,
      total: 0,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$store.state.Refresh) {
        console.log("刷新",vm);
        vm.reload(); //调用app.vue的方法
      } else {
        console.log("不刷新");
      }
    });
  },
  created() {
    if((window.location.href).indexOf('?')>-1){
      let url = this.tool.getUrl(window.location.href)
      this.from = url
      this.from1 = url
      this.value1 = [this.from.create_time.split('~')[0],this.from.create_time.split('~')[1]]
      this.currentPage = Number(this.from.page)
      this.from.pageSize = Number(this.from.pageSize)
    }
    this.hqlist();
  },
  methods: {
    search() {
      if (this.value1 != null) {
        if (this.value1.length > 0) {
          this.from.create_time = this.$time.time(this.value1[0])+'~'+this.$time.time(this.value1[1]);
       
          console.log(this.from.create_time, "时间");
        } else {
          this.from.create_time = "";
          
        }
      } else {
        this.from.create_time = "";
     
      }
      this.from.page = 1;
      this.currentPage = 1;
      this.from1 = this.from;
      this.tool.getResult(this.from1,window.location.href)
      this.hqlist();
    },

    Refresh() {
      this.value1=[]
      this.from = {
        page: 1,
        pageSize: 10,
        create_time:''
      };
      this.from1 = {
        page: 1,
        pageSize: 10,
        create_time:''
      };
      this.value1 = [];
      this.currentPage = 1;
      this.tool.getResult(this.from1,window.location.href)
      this.hqlist();
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;
      this.from1.pageSize = val;
      this.tool.getResult(this.from1,window.location.href)
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.from1.page = val;
      this.currentPage = val;
      this.tool.getResult(this.from1,window.location.href)
      this.hqlist();
    },
    handleEdit(row) {
      this.$router.push({
        path: `/Receivingdetails`,
        query: {
          id: row.id,
        },
      });
    },

    hqlist() {
      this.loading = true;
      this.$api.delivery.orderlist(this.from1).then((res) => {
        console.log(res, "获取数据");
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.loading = false;
      });
    },
  },
};
</script>
  <style lang="scss">
.Receiving {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;
  .title {
    background: #ffffff;
    padding: 13px 15px;
    box-sizing: border-box;
    display: flex;
    .seach {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      .inputs {
        width: 207px;
        margin-right: 8px;
      }
    }
    .bjsearch {
      background: #333333;
      border-color: #333333;
    }
  }

  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }
  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }
  .contents {
    padding-left: 55px;
    padding-right: 55px;
    padding-top: 23px;

    box-sizing: border-box;
    .titlname {
      font-size: 17px;
      color: #21c2ac;
      margin-bottom: 25px;
    }
    .imgs {
      display: flex;
      .imglist {
        width: 165px;
        height: 123px;
        border: 1px dashed #a4adc5;
        padding: 14px 8px;
        text-align: center;
        border-radius: 7px;
        box-sizing: border-box;
        margin-right: 16px;
        .div {
          margin-top: 20px;
          padding-bottom: 20px;
        }
        // img{
        //     width: 100%;
        //     height: 100%;
        // }
      }
    }
    .disply {
      display: flex;
      margin-bottom: 22px;
    }
    .mr {
      margin-right: 31px;
    }
    .iteminput {
      display: flex;
      align-items: center;

      .wen {
        width: 77px;
        margin-right: 24px;
        color: #000;
        font-size: 14px;
        text-align: right;
      }
      .el-input {
        width: 302px;
      }
    }
  }
}
.colors {
  color: #fa884c;
}
.times {
  margin-right: 8px;
}
</style>
  